import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { ReadTaskPermission } from '@auth/permissionsEnum'
import ReaderTaskListIAMTabs from '@features/reader_task_list_iam_view/pages/pages/ReaderTaskListIAMTabs'
import ReaderTaskListTabs from './ReaderTaskListTabs'
import { SearchProvider } from '@common/context/SearchProvider'
import { SigningContextProvider } from '@features/reader_task_list_iam_view/pages/hooks/useSigningContext'
import ReaderSummaryModal from '@features/reader_summary/pages/pages/ReaderSummaryModal'
import { useParams } from 'react-router-dom'
import useGetReadDesignDetails from '@reader_task_list_view/hooks/useGetReadDesignDetails'
import { useEffect, useState } from 'react'

export default function ReaderTaskView() {
  const { hasPermission } = useCombinedPermissions()
  const { studyId } = useParams<{ studyId: string }>()
  const { data: readDesigns, isPending: isReadDesignDataLoading } = useGetReadDesignDetails(studyId!)
  const [isRawDataEnabled, setRawDataEnabled] = useState(false)

  const isIAMUser = hasPermission(ReadTaskPermission.MANAGE_READ_TASK)

  useEffect(() => {
    if (!isReadDesignDataLoading && readDesigns) {
      let rawDataFlagFound = false
      for (const element of readDesigns) {
        if (element.enable_raw_data) {
          rawDataFlagFound = true
          break
        }
      }
      setRawDataEnabled(rawDataFlagFound)
    }
  }, [isReadDesignDataLoading, readDesigns])

  return (
    <SigningContextProvider>
      <SearchProvider>
        {isIAMUser ? <ReaderTaskListIAMTabs /> : <ReaderTaskListTabs />}

        <ReaderSummaryModal studyId={studyId} isRawDataEnabled={isRawDataEnabled} />
      </SearchProvider>
    </SigningContextProvider>
  )
}
